// extracted by mini-css-extract-plugin
export default {"ArticleListAnchorSelect":"pdEmTJ9UhMZxk2sekfJm"};